import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import * as i0 from "@angular/core";
export class BasePathService {
    constructor() {
        this.basePath$ = new BehaviorSubject("");
    }
    /**
     * removes the basePath from the given path
     */
    removeBasePath(path) {
        const reducedBasePath = path?.replace(this.basePath$.value, "");
        return this.trimSlashes(reducedBasePath);
    }
    /**
     * prefixes given path with the basePath
     */
    addBasePath(path) {
        path = this.trimSlashes(path);
        return this.basePath$.value + "/" + path;
    }
    trimSlashes(path) {
        if (path.startsWith("/"))
            path = path.substr(1);
        if (path.endsWith("/"))
            path = path.substr(0, path.length - 1);
        return path.trim();
    }
}
BasePathService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: BasePathService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BasePathService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: BasePathService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: BasePathService, decorators: [{
            type: Injectable,
            args: [{ providedIn: "root" }]
        }] });
